import { bulkDeleteOrdersAction } from './bulk-delete-orders';

export default [bulkDeleteOrdersAction];
